import React, { useEffect, useState } from "react";
import { SECTIONS } from "../data/copy";

/**
 * Right-side mint scroll-progress dots. One dot per section.
 * Active section detected via IntersectionObserver at 0.5;
 * active dot scales 1.4x and turns mint-ink. Hidden < 760px (CSS).
 */
export const ProgressDots = () => {
  const [active, setActive] = useState("hero");

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) setActive(entry.target.id);
        });
      },
      { threshold: 0.5 }
    );
    SECTIONS.forEach(({ id }) => {
      const el = document.getElementById(id);
      if (el) observer.observe(el);
    });
    return () => observer.disconnect();
  }, []);

  return (
    <nav className="mk-dots-rail" aria-label="Section progress" data-testid="progress-dots">
      {SECTIONS.map(({ id, label }) => (
        <a
          key={id}
          href={`#${id}`}
          className={`mk-rail-dot ${active === id ? "is-active" : ""}`}
          aria-label={label}
          aria-current={active === id ? "true" : undefined}
          data-testid={`progress-dot-${id}`}
        />
      ))}
    </nav>
  );
};

export default ProgressDots;
